import styled from "styled-components";
import { PasosEstiloNaturalDecision } from "./EstiloNaturalDecisionContainer";
import backgroundAzul from "../../assets/images/estilo-natural-decision/blue-background.png";

interface ContainerProps {
  paso?: PasosEstiloNaturalDecision;
}

// Define constants
const generalPadding = "20px";
const headerHeight = "70px";

export const LogoContainer = styled.div``;
export const TextContainer = styled.div``;
export const EstiloAprendizajeHeader = styled.div``;
export const EstiloNaturalDecisionQuestionsContainer = styled.div``;
export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 10px; /* Adjust as needed */
  right: 10px; /* Adjust as needed */
  z-index: 10; /* Ensure it stays on top */

  img {
    height: 65px;
    cursor: pointer;
  }
`;
export const ChartContainer = styled.div`
  max-height: 100%;  
`;
export const EstiloNaturalDecisionQuestion = styled.div``;
export const EstiloNaturalDecisionAnswers = styled.div``;

const romanNumerals: Record<number, string> = {
  1: "I",
  2: "II",
  3: "III",
  4: "IV",
  5: "V",
  6: "VI",
  7: "VII",
  8: "VIII",
  9: "IX",
  10: "X",
  11: "XI",
  12: "XII"
};

const getRomanNumeral = (number: number): string => {
  return romanNumerals[number] || "XX";
};

interface EstiloNaturalDecisionQuestionTitleProps {
  number: number;
}

export const EstiloNaturalDecisionQuestionTitle = styled.div<EstiloNaturalDecisionQuestionTitleProps>`
  span {
    font-size: 14px;
    border: 2px solid #01384d;
    background-color: white;
    padding: 5px;
    text-transform: capitalize;
    border-radius: 20px;
    position: relative;
    height: 30px;
    z-index: 1;
    padding-left: 25px;

    &:before {
      border: 2px solid #01384d;
      content: "";
      position: absolute;
      left: -30px;
      top: -10px;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: white;
    }

    &:after {
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 20px;
      content: ${({ number }) => `"${getRomanNumeral(number)}"`};
      position: absolute;
      left: -25px;
      top: -5px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #01384d;
      z-index: 2;
    }
  }
`;

const getBackgroundColorForEstiloNaturalDecisionQuestionsContainer = (
  paso: PasosEstiloNaturalDecision
) => {
  switch (paso) {
    case PasosEstiloNaturalDecision.Informe:
      return "#FFF";
    case PasosEstiloNaturalDecision.Instrucciones:
      return "";
    case PasosEstiloNaturalDecision.Preguntas:
      return "#dadada";
  }
};

const getColorForEstiloNaturalDecisionContainer = (
  paso: PasosEstiloNaturalDecision
) => {
  switch (paso) {
    case PasosEstiloNaturalDecision.Informe:
      return "#FFF";
    case PasosEstiloNaturalDecision.Instrucciones:
      return "#FFF";
    case PasosEstiloNaturalDecision.Preguntas:
      return "#383838";
  }
};

export const EstiloNaturalDecisionContainerStyled = styled.div<ContainerProps>`
  background-color: ${(props) =>
    props.paso === PasosEstiloNaturalDecision.Preguntas ? "#FFF" : "#027381"};
  background: url(${(props) =>
    props.paso === PasosEstiloNaturalDecision.Preguntas
      ? "inherit"
      : backgroundAzul});
  background-size: cover;
  height: 100%;
  max-height: 100vh;
  padding: ${generalPadding};
  overflow-y: auto;
  font-family: "poppins";
  position: relative;

  ${EstiloAprendizajeHeader} {
    display: flex;
    justify-content: space-between;
    font-family: "poppins bold";
    align-items: center;
    height: ${headerHeight};

    ${TextContainer} {
      font-size: 20px;
      color: ${(props) =>
        props.paso == PasosEstiloNaturalDecision.Preguntas
          ? "#003550"
          : "#FFF"};
      span {
        font-size: 21px;

        &.estilo {
          color: ${(props) =>
            props.paso == PasosEstiloNaturalDecision.Preguntas
              ? "#003550"
              : "#FFF"};
        }
        &.natural {
          color: #003550;
        }
        &.decision {
          color: rgb(182, 184, 50);
        }

        @media only screen and (min-width: 0) and (max-width: 768px) {
          font-size: 14px;
        }

        @media only screen and (min-width: 768px) and (max-width: 1024px) {
          font-size: 14px;
        }
      }

      @media only screen and (min-width: 0) and (max-width: 768px) {
        font-size: 16px;
      }

      @media only screen and (min-width: 768px) and (max-width: 1024px) {
        font-size: 16px;
      }
    }

    ${LogoContainer} {
      .logoleft {
        height: 40px;
        margin-right: 50px;
        @media only screen and (min-width: 0) and (max-width: 768px) {
          height: 30px;
          margin-right: 0;
        }

        @media only screen and (min-width: 768px) and (max-width: 1024px) {
          height: 30px;
          margin-right: 0;
        }
      }

      .logoright {
        height: 50px;
        @media only screen and (min-width: 0) and (max-width: 768px) {
          height: 30px;
        }

        @media only screen and (min-width: 768px) and (max-width: 1024px) {
          height: 30px;
        }
      }

      @media only screen and (min-width: 0) and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: start;
      }

      @media only screen and (min-width: 768px) and (max-width: 1024px) {
        display: flex;
        flex-direction: column;
        align-items: start;
      }
    }

    @media only screen and (min-width: 0) and (max-width: 768px) {
      display: flex;
      justify-content: space-between;
    }

    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      height: 30px;
    }
  }

  ${EstiloNaturalDecisionQuestionsContainer} {
    font-size: 14px;
    color: ${(props) =>
      getColorForEstiloNaturalDecisionContainer(
        props.paso || PasosEstiloNaturalDecision.Instrucciones
      )};
    margin: 20px 0;
    border-radius: 20px;
    padding: 20px;
    top: ${headerHeight};
    left: ${generalPadding};
    right: ${generalPadding};
    bottom: ${generalPadding};
    overflow-y: auto;

    ${ChartContainer} {      
      background-color: #fff;      
      border-radius: 20px;
      padding: 20px;
    }
  }

  ${EstiloNaturalDecisionQuestionTitle} {
    color: #01384d;
    text-align: center;
    font-weight: 900;
    font-size: 20px;
  }

  ${EstiloNaturalDecisionQuestion} {
    background-color: red;
    margin: -20px;
    border-radius: 20px;
    padding: 20px;
    background: #dadada;
  }

  ${EstiloNaturalDecisionAnswers} {
    margin: -20px;
    padding: 20px;

    ul {
      position: relative;
      padding: 0;
      list-style-type: none;

      li {
        display: flex;
        justify-content: start;
        align-items: center;

        input {
          width: 40px;
          height: 40px;
          margin: 0 20px 0 0; /* Adjust the margin to align properly */
          flex-shrink: 0; /* Prevent shrinking */
        }

        .marker {
          margin-left: 10px;
          color: white;
          font-size: 35px;
          background-color: #027381;
          border-radius: 10px;
          position: relative;
          display: inline-block;
          padding-left: 10px;
          border-radius-top-right: 0;
          border-radius-bottom-right: 0;

          &:after {
            position: absolute;
            content: "";
            width: 0;
            height: 0;
            border-top: 22px solid transparent;
            border-bottom: 22px solid transparent;
            border-left: 22px solid #027381;
            top: 5px;
            margin-left: -2px;
          }
        }

        label {
          font-size: 14px;
          display: block;
          cursor: pointer;
          padding: 10px;
          margin: 10px;
          /* margin-left: 40px; */
          border-radius: 20px;
          background-color: #fff;
          /* border: 2px solid #01384d; */
          transition: all 0.3s ease;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
          color: #027381;
          font-weight: 900;
          font-family: "poppins bold";
          flex-grow: 1;
          background-color: #ededed;
          padding-left: 70px;
          margin-left: -40px;
        }
      }
    }
  }
`;
